import React from "react";
import styled from "styled-components";
import { textStyle, spacing } from "../../dimensions";
import SeatInfov2 from "../SeatInfov2";
import { getBackgroundColor } from "../TicketCardv2";
import TicketInfoHeader from "./TicketInfoHeader";
import SimpleSeatInfo from "../SimpleSeatInfo";
var TicketTopSection = function TicketTopSection(_ref) {
  var accessibleTitle = _ref.accessibleTitle,
    headerTitle = _ref.headerTitle,
    row = _ref.row,
    seat = _ref.seat,
    section = _ref.section,
    ticketInfoButtonData = _ref.ticketInfoButtonData,
    type = _ref.type,
    wayfindingColors = _ref.wayfindingColors,
    voucherDisclaimer = _ref.voucherDisclaimer;
  var shouldDisplayHeader = accessibleTitle || headerTitle || ticketInfoButtonData;
  if (type === "addedValue") {
    return /*#__PURE__*/React.createElement(TopSectionWrapper, {
      $type: type
    }, /*#__PURE__*/React.createElement(TicketInfoHeader, {
      type: type,
      headerTitle: headerTitle
    }), /*#__PURE__*/React.createElement(AddedValueInfoWrapper, null, voucherDisclaimer && /*#__PURE__*/React.createElement(VoucherDisclaimer, null, voucherDisclaimer), /*#__PURE__*/React.createElement(SimpleSeatInfo, {
      row: row,
      seat: seat,
      section: section
    })));
  }
  return /*#__PURE__*/React.createElement(TopSectionWrapper, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, shouldDisplayHeader && /*#__PURE__*/React.createElement(TicketInfoHeader, {
    accessibleTitle: accessibleTitle,
    ticketInfoButtonData: ticketInfoButtonData,
    type: type,
    headerTitle: headerTitle,
    wayfindingColors: wayfindingColors
  }), /*#__PURE__*/React.createElement(SeatInfoWrapper, null, /*#__PURE__*/React.createElement(SeatInfov2, {
    row: row,
    seat: seat,
    section: section,
    type: type,
    wayfindingColors: wayfindingColors
  })));
};
export default TicketTopSection;
export var TopSectionWrapper = styled.div.withConfig({
  displayName: "TicketTopSection__TopSectionWrapper",
  componentId: "sc-11bz39i-0"
})(["display:flex;flex-direction:column;gap:", ";width:100%;padding:", " ", ";background-color:", ";"], function (_ref2) {
  var $type = _ref2.$type;
  return $type === "addedValue" ? spacing.club : spacing.amphitheatre;
}, spacing.auditorium, spacing.hall, function (_ref3) {
  var $type = _ref3.$type,
    $wayfindingColors = _ref3.$wayfindingColors;
  return getBackgroundColor($type, $wayfindingColors);
});
var SeatInfoWrapper = styled.div.withConfig({
  displayName: "TicketTopSection__SeatInfoWrapper",
  componentId: "sc-11bz39i-1"
})(["padding:0 ", ";"], spacing.hall);
var AddedValueInfoWrapper = styled.div.withConfig({
  displayName: "TicketTopSection__AddedValueInfoWrapper",
  componentId: "sc-11bz39i-2"
})(["display:flex;flex-direction:column;align-items:center;"]);
var VoucherDisclaimer = styled.p.withConfig({
  displayName: "TicketTopSection__VoucherDisclaimer",
  componentId: "sc-11bz39i-3"
})(["", ";margin:0;"], textStyle.snowdon);